import { BrowserRouter, Link, Route, Routes } from "react-router-dom";
import { WalletProvider, useWallet } from "./wallet/context";
import { HomePage } from "./pages/HomePage";
import { LinkPage } from "./pages/LinkPage";
import { MePage } from "./pages/MePage";
import { ClaimNewPage } from "./pages/ClaimNewPage";
import { ClaimPage } from "./pages/ClaimPage";
import { VouchPage } from "./pages/VouchPage";
import { VouchDonePage } from "./pages/VouchDonePage";
import { VerifyPage } from "./pages/VerifyPage";
import { HolderPage } from "./pages/HolderPage";
import { IssuerPage } from "./pages/IssuerPage";
import { OfferPage } from "./pages/OfferPage";
import { HowItWorksPage } from "./pages/HowItWorksPage";
import { PrivacyPage } from "./pages/PrivacyPage";
import { BuildPage } from "./pages/BuildPage";
import { LivePage } from "./pages/LivePage";
import { OrgsPage } from "./pages/OrgsPage";
import { shortDid } from "./util";

function Header() {
  const { identity } = useWallet();
  return (
    <header className="top">
      <Link to="/" className="brand">QSeverse <span>Vouch</span></Link>
      <Link to="/me" className="chip-id" data-testid="whoami">{identity ? shortDid(identity.did) : "No key yet"}</Link>
    </header>
  );
}

export function App() {
  return (
    <WalletProvider>
      <BrowserRouter>
        <div className="shell">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/me" element={<MePage />} />
              <Route path="/me/link" element={<LinkPage />} />
              <Route path="/claim" element={<ClaimNewPage />} />
              <Route path="/c/:id" element={<ClaimPage />} />
              <Route path="/c/:id/verify" element={<VerifyPage />} />
              <Route path="/verify" element={<VerifyPage />} />
              <Route path="/v/:token" element={<VouchPage />} />
              <Route path="/v/:token/done" element={<VouchDonePage />} />
              <Route path="/d/:did" element={<HolderPage />} />
              <Route path="/issuer/:did" element={<IssuerPage />} />
              <Route path="/offer/:id" element={<OfferPage />} />
              <Route path="/how-it-works" element={<HowItWorksPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/build" element={<BuildPage />} />
              <Route path="/orgs" element={<OrgsPage />} />
              <Route path="/live" element={<LivePage />} />
              <Route path="*" element={<p className="note">Nothing here.</p>} />
            </Routes>
          </main>
          <footer className="foot">
            <Link to="/how-it-works">How it works</Link><Link to="/orgs">Organisations</Link><Link to="/live">Live</Link><Link to="/privacy">Trust and privacy</Link><Link to="/build">Build</Link>
          </footer>
        </div>
      </BrowserRouter>
    </WalletProvider>
  );
}
